import { defineComponent, reactive, computed, ref, watch, onMounted, getCurrentInstance } from "vue";
import Uploader from "./uploader.vue";
import i18n from "@/lang";
import CreditsCostTips from "@com/components/credits-cost-tips/index.vue";
import { MainPlan } from "@ve-pro/enums/plan";
import { MessageBox } from "element-ui";
import { addPointerEventsNoneToIframes, removePointerEventsNoneFromIframes } from "@com/utils/iframe-pointer-events-util";
import { usageType } from "@com/components/credits-cost-tips/utils";
import { isRecharge } from "@pt/store/user/helper";
import { language } from "@/common/storage";
import { getRouteHelperUrlByDomain } from "@com/utils/helper";
import { isCNSuffix } from "@com/utils/url";
export default defineComponent({
    components: {
        CreditsCostTips: CreditsCostTips,
        Uploader: Uploader
    },
    props: {
        dialogVisible: {
            type: Boolean,
            required: true
        },
        dialogTitle: {
            type: String,
            default: ""
        },
        multiple: {
            type: Boolean,
            default: true
        },
        redirect: {
            type: Boolean,
            default: true
        },
        serviceBtnVisible: {
            type: Boolean,
            default: false
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var reset = function reset() {
            fileList.value = [];
            extraFromModel.remark = "";
        };
        var handleSubmit = function handleSubmit() {
            MessageBox.confirm(submitDesc.value, t("playTurbo.order.3dmodel.dialog.submit"), {
                confirmButtonText: t("playTurbo.order.3dmodel.dialog.confirm"),
                cancelButtonText: t("playTurbo.whole.cancel"),
                customClass: "pt-custom-confirm-message",
                center: true,
                type: "warning"
            }).then(function() {
                emit("submit", {
                    fileList: fileList.value,
                    extra: extraFromModel,
                    usage_type: usage_Type.value
                });
            }).catch(function() {
                console.log("cancel");
            });
        };
        var handleCostChange = function handleCostChange(data) {
            cost.value = data.cost;
            balance.value = data.balance;
        };
        var handleCostMoneyChange = function handleCostMoneyChange(data) {
            costMoney.value = data.cost;
            moneyBalance.value = data.balance;
        };
        var instance = getCurrentInstance();
        var root = instance === null || instance === void 0 ? void 0 : instance.proxy;
        var t = function(path) {
            return root.$t(path).toString();
        };
        var store = root.$store;
        var innerDialog = {
            appendToBody: true,
            class: "pt-dialog",
            width: "720px"
        };
        var fileList = ref([]);
        watch(function() {
            return props.dialogVisible;
        }, function(val) {
            if (!val) {
                removePointerEventsNoneFromIframes();
                reset();
            } else {
                addPointerEventsNoneToIframes();
            }
        });
        var visible = computed({
            get: function() {
                return props.dialogVisible;
            },
            set: function(val) {
                emit("update:dialogVisible", val);
            }
        });
        var extraFromVisible = ref(false);
        var extraFromModel = reactive({
            remark: ""
        });
        var extraFromSchema = computed(function() {
            return {
                type: "object",
                properties: {
                    remark: {
                        label: i18n.t("playTurbo.order.table.column.remark"),
                        component: "input",
                        field: {
                            placeholder: i18n.t("playTurbo.order.3dmodel.tips.remark")
                        }
                    }
                }
            };
        });
        var extraFormConfig = {
            inline: false
        };
        var listPath = "/creative-service/demand-order";
        var submitButton = computed(function() {
            return {
                disabled: fileList.value.length === 0
            };
        });
        var currentLanguage = ref("");
        var navigatotHelpCenter = function() {
            if (isCNSuffix()) {
                window.open(getRouteHelperUrlByDomain("cn", "ke-wan-gong-ju-huan-fu-bian-ji-qi/huan-fu-bian-ji-qi-shi-yong-zhi-nan/te-shu-gong-neng-3d-mu-ban/3d-mo-xing-gong-dan"), "_blank");
            } else {
                window.open(getRouteHelperUrlByDomain("com", "playable-tools-feature-changer/feature-changer-user-guide/special-feature-3d-templates/3d-model-order"), "_blank");
            }
        };
        var cost = ref(0);
        var balance = ref(0);
        var costMoney = ref(0);
        var moneyBalance = ref(0);
        var usage_Type = ref("");
        var moneyTipsVisible = ref(false);
        var creditTipsVisible = ref(false);
        var submitDesc = computed(function() {
            return usage_Type.value === usageType.money ? root.$t("playTurbo.order.3dmodel.tips.moneySubmit", {
                count: costMoney.value,
                balance: moneyBalance.value.toFixed(2)
            }) : root.$t("playTurbo.order.3dmodel.tips.videoSubmit", {
                count: cost.value,
                balance: balance.value
            });
        });
        // 是否充值套餐账号
        var isRechargePlans = computed(function() {
            return isRecharge(store.state.user.info);
        });
        var warning = computed(function() {
            return {
                creditWraning: balance.value === 0 || balance.value < cost.value,
                moneyWraning: moneyBalance.value === 0 || moneyBalance.value < costMoney.value
            };
        });
        var tipsVisible = function() {
            if (isRechargePlans.value) {
                moneyTipsVisible.value = true;
                usage_Type.value = usageType.money;
            } else {
                creditTipsVisible.value = true;
                usage_Type.value = usageType.video_credits;
            }
        };
        onMounted(function() {
            tipsVisible();
            currentLanguage.value = language.get();
        });
        return {
            warning: warning,
            fileList: fileList,
            visible: visible,
            extraFromVisible: extraFromVisible,
            innerDialog: innerDialog,
            listPath: listPath,
            submitButton: submitButton,
            extraFromModel: extraFromModel,
            extraFromSchema: extraFromSchema,
            extraFormConfig: extraFormConfig,
            navigatotHelpCenter: navigatotHelpCenter,
            MainPlan: MainPlan,
            moneyTipsVisible: moneyTipsVisible,
            creditTipsVisible: creditTipsVisible,
            handleSubmit: handleSubmit,
            handleCostChange: handleCostChange,
            handleCostMoneyChange: handleCostMoneyChange,
            usageType: usageType,
            usage_Type: usage_Type,
            tipsVisible: tipsVisible
        };
    }
});
